import ButtonDesigned from '../../../../../components/UI-Elements/Buttons/ButtonDesigned';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import React, { useState } from 'react';

interface ButtonSectionProps {
  onModifyOrder: () => void;
  fileDBUrl: string;
  setShowOverlay: (_value: React.SetStateAction<boolean>) => void;
  routeToBackPage: () => void;
  isEditable?: boolean;
}

export const FOIndexedButtonSection: React.FC<ButtonSectionProps> = ({
  fileDBUrl,
  onModifyOrder,
  setShowOverlay,
  routeToBackPage,
  isEditable = true,
}) => {
  const [isModifyButtonLoading, setIsModifyButtonLoading] = useState(false);

  const onModifyWithLoadingIndicator = async () => {
    setIsModifyButtonLoading(true);
    await onModifyOrder();
    setIsModifyButtonLoading(false);
  };

  return (
    <div className="flex flex-row gap-4 sticky bottom-0 pt-1 bg-white">
      {isEditable && (
        <ButtonDesigned
          style="outline"
          className=" flex items-center"
          onButtonClick={() => {
            routeToBackPage();
          }}
        >
          <img className=" my-auto rotate-180" title="Right" src="/assets/icons/flat/chevron-right_purple.svg"></img>
          Back
        </ButtonDesigned>
      )}
      <ButtonDesigned
        style="outline"
        onButtonClick={onModifyWithLoadingIndicator}
        isFunctionLoading={isModifyButtonLoading}
        disableButton={isModifyButtonLoading}
      >
        <BorderColorOutlinedIcon className="text-blue-600" />
        Modify
      </ButtonDesigned>
      <ButtonDesigned
        disableButton={fileDBUrl.length === 0}
        style="outline"
        onButtonClick={() => {
          fileDBUrl && setShowOverlay(true);
        }}
      >
        <ArticleOutlinedIcon className="text-blue-600 " />
        View contract
      </ButtonDesigned>
    </div>
  );
};
